import {
  showSideMenuUI,
  hideSideMenuUI,
  setInertByActiveMenus,
} from './helper';

class HeaderRelaunch2025 {
  constructor(options = {}) {
    this.element = options.element;
    this.scroller = options.scroller || window;
    this.lastScroll = 0;
    this.hideOffset = 200;
    this.marginTop = '12px';
    this.isTicking = false;
    this.isSideMenuOpen = false;

    this.menuButton = this.element.querySelector('.menu-label');
    this.searchButton = this.element.querySelector('.search-btn');
    this.topNavLinks = this.element.querySelectorAll('.top-navigation__nav button');

    this.sideMenu = document.getElementById('headerSideMenu');
    this.sideMenuNavContainer = this.sideMenu.querySelector('.nav');
    this.closeButtons = this.sideMenu.querySelectorAll('.nav__close-btn');
    this.searchInput = this.sideMenu.querySelector('#navSearch');
    this.menu1 = this.sideMenu.querySelector('.nav__menu-1');
    this.languageSwitch = this.sideMenu.querySelector('.nav__lang');

    this.overlay = document.getElementById('sideMenuOverlay');
  }

  init() {
    this.element.style.position = this.element.style.position || 'sticky';
    this.element.style.top = this.element.style.top || this.marginTop;

    this.showHeader();
    this.lastScroll = this.getScrollY();

    this.scrollBehavior();
    this.setupMenuToggle();
    this.setupMenuTransitions();
    this.setMenuWrapperHeight();
    this.setupTopNavTriggers();
  }

  scrollBehavior() {
    this.scroller.addEventListener('scroll', () => {
      if (this.isTicking || this.isSideMenuOpen) {
        return;
      }

      this.isTicking = true;
      window.requestAnimationFrame(() => {
        const currentScroll = this.getScrollY();

        if (currentScroll <= this.hideOffset) {
          this.showHeader();
        } else if (currentScroll > this.lastScroll) {
          this.hideHeader();
        } else if (currentScroll < this.lastScroll) {
          this.showHeader();
        }

        this.lastScroll = currentScroll;
        this.isTicking = false;
      });
    }, { passive: true });
  }

  getScrollY() {
    return this.scroller === window ?
      (window.scrollY || window.pageYOffset || 0) :
      this.scroller.scrollTop || 0;
  }

  closeSideMenu() {
    this.sideMenuNavContainer.classList.remove('is-visible');
    this.isSideMenuOpen = false;
    this.showHeader();

    this.menu1.classList.remove('slide-in', 'menu2IsOpen', 'menu3IsOpen');
    this.sideMenu.querySelectorAll('.nav__menu-2, .nav__menu-3')
      .forEach((menu) => {
        menu.classList.remove('slide-in', 'slide-out', 'menu2IsOpen', 'menu3IsOpen');
      });

    this.sideMenu.querySelectorAll('.nav, .nav__lang, .nav__menu-1, .nav__menu-2, .nav__menu-3')
      .forEach((menu) => {
        menu.setAttribute('inert', ''); // alle Menus inaktiv
      });


    hideSideMenuUI(this.sideMenuNavContainer, this.overlay, this.element);
    setInertByActiveMenus(this.sideMenu);
    this.setTopNavigationInert(false);
  }

  showHeader() {
    this.element.classList.remove('header--hidden');
  }

  hideHeader() {
    this.element.classList.add('header--hidden');
  }

  setupMenuToggle() {
    this.menuButton.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'instant' });
      this.isSideMenuOpen = true;
      this.menu1.classList.add('slide-in');

      this.sideMenuNavContainer.removeAttribute('inert', '');
      this.menu1.removeAttribute('inert');
      this.languageSwitch.removeAttribute('inert');

      showSideMenuUI(this.sideMenuNavContainer, this.overlay, this.element);
      setInertByActiveMenus(this.sideMenu);
    });

    if (this.searchButton && this.searchInput) {
      this.searchButton.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'instant' });
        this.isSideMenuOpen = true;
        this.menu1.classList.add('slide-in');

        this.sideMenuNavContainer.removeAttribute('inert', '');
        this.menu1.removeAttribute('inert');
        this.languageSwitch.removeAttribute('inert');

        showSideMenuUI(this.sideMenuNavContainer, this.overlay, this.element);
        setInertByActiveMenus(this.sideMenu);

        // eslint-disable-next-line no-restricted-globals
        setTimeout(() => this.searchInput.focus(), 400);
      });
    }

    document.addEventListener('focusin', (event) => {
      const target = event.target;
      const isInMain = target.closest('main');
      const isInFooter = target.closest('footer');

      if ((isInMain || isInFooter) && this.isSideMenuOpen && !this.sideMenu.contains(target)) {
        this.closeSideMenu();
      }
    });

    if (this.closeButtons) {
      this.closeButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          this.closeSideMenu();
        });
      });
    }
  }

  setupMenuTransitions() {
    this.setupMenu1toMenu2();
    this.setupMenu2toMenu3();
    this.setupBackLinksMenu2();
    this.setupBackLinksMenu3();
  }

  // Menü-1 → Menü-2
  setupMenu1toMenu2() {
    const menu1Links = this.menu1.querySelectorAll('button[id]');
    menu1Links.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = link.getAttribute('id');
        const subMenu = this.sideMenu.querySelector(`.nav__menu-2[data-id="${targetId}"]`);

        if (subMenu) {
          this.menu1.classList.remove('slide-in');
          this.menu1.classList.add('menu2IsOpen');
          subMenu.removeAttribute('inert');
          subMenu.classList.add('slide-in');
          // subMenu.style.display = 'block';

          setInertByActiveMenus(this.sideMenu);
        }
      });
    });
  }

  // Menü-2 → Menü-3
  setupMenu2toMenu3() {
    const menu2Links = this.sideMenu.querySelectorAll('.nav__menu-2 button[id]');
    menu2Links.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = link.getAttribute('id');
        const subMenus = this.sideMenu.querySelectorAll(`.nav__menu-3[data-id="${targetId}"]`);

        if (subMenus.length > 0) {
          const parentMenu2 = link.closest('.nav__menu-2');
          parentMenu2.classList.remove('slide-in');
          parentMenu2.classList.add('menu3IsOpen');
          this.menu1.classList.remove('menu2IsOpen');
          this.menu1.classList.add('menu3IsOpen');

          subMenus.forEach((subMenu) => {
            subMenu.removeAttribute('inert');
            subMenu.classList.add('slide-in');
            setInertByActiveMenus(this.sideMenu);
          });
        }
      });
    });
  }

  // Backlinks Menü-2 → Menü-1
  setupBackLinksMenu2() {
    const backLinks2 = this.sideMenu.querySelectorAll('.nav__menu-2 .nav__back a');
    backLinks2.forEach((back) => {
      back.addEventListener('click', (event) => {
        event.preventDefault();
        const menu2 = back.closest('.nav__menu-2');

        menu2.classList.remove('slide-in');
        menu2.classList.remove('menu3IsOpen');
        menu2.setAttribute('inert', '');

        this.menu1.classList.add('slide-in');
        setInertByActiveMenus(this.sideMenu);
        this.menu1.classList.remove('menu2IsOpen');
        this.menu1.classList.remove('menu3IsOpen');
      });
    });
  }

  // Backlinks Menü-3 → Menü-2
  setupBackLinksMenu3() {
    const backLinks3 = this.sideMenu.querySelectorAll('.nav__menu-3 .nav__back a');
    backLinks3.forEach((back) => {
      back.addEventListener('click', (event) => {
        event.preventDefault();
        const menu3 = back.closest('.nav__menu-3');
        const parentId = menu3.getAttribute('data-id');
        const parentMenu2 = this.sideMenu.querySelector(`.nav__menu-2 button[id="${parentId}"]`).closest('.nav__menu-2');

        if (parentMenu2) {
          this.menu1.classList.add('menu2IsOpen');
          this.menu1.classList.remove('slide-in');

          parentMenu2.classList.add('slide-in');
          setInertByActiveMenus(this.sideMenu);
          parentMenu2.removeAttribute('inert');

          menu3.classList.remove('slide-in');
          menu3.classList.remove('menu3IsOpen');
          menu3.setAttribute('inert', '');
        }
      });
    });
  }

  setMenuWrapperHeight() {
    const wrapper = this.sideMenu.querySelector('.nav__menu-wrapper');
    if (wrapper && this.menu1) {
      const height = this.menu1.offsetHeight;
      wrapper.style.height = `${height}px`;
    }
  }

  setupTopNavTriggers() {
    if (!this.topNavLinks.length) {
      return;
    }

    this.topNavLinks.forEach((link) => {
      // ID aus href holen
      const targetId = link.getAttribute('id');
      if (!targetId) {
        return;
      }

      link.addEventListener('click', (event) => {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: 'instant' });
        this.isSideMenuOpen = true;

        // SideMenu anzeigen
        showSideMenuUI(this.sideMenuNavContainer, this.overlay, this.element);
        this.setTopNavigationInert(true);

        // Zugehöriges Menü-2 im SideMenu suchen
        const targetMenu2 = this.sideMenu.querySelector(`.nav__menu-2[data-id="${targetId}"]`);
        if (targetMenu2) {

          this.menu1.classList.remove('slide-in');
          this.menu1.classList.add('menu2IsOpen');
          targetMenu2.classList.add('slide-in');
          setInertByActiveMenus(this.sideMenu);

          this.sideMenuNavContainer.removeAttribute('inert', '');
          this.menu1.removeAttribute('inert');
          targetMenu2.removeAttribute('inert');
        }
      });
    });

  }

  setTopNavigationInert(isInert) {
    const topNav = this.element.querySelector('.top-navigation');
    if (!topNav) {
      return;
    }

    if (isInert) {
      topNav.setAttribute('inert', '');
    } else {
      topNav.removeAttribute('inert');
    }
  }
}

export default HeaderRelaunch2025;
